import React from 'react'

const PortailPatients = () => {
  return (
    <div>PortailPatients</div>
  )
}

export default PortailPatients